/* eslint-disable react/no-multi-comp */
import React from 'react';
import { View } from 'react-native';

export const DefComp = props => <defs>{props.children}</defs>;

export const UseComp = props => <use {...props} />;

export const EllipseComp = props => <ellipse {...props} />;

export const LinearGradientComp = props => {
  const { id, x1, y1, x2, y2, gradientUnits } = props;
  return (
    <linearGradient id={id} x1={x1} y1={y1} x2={x2} y2={y2} gradientUnits={gradientUnits}>
      {props.children}
    </linearGradient>
  );
};
export const RadialGradientComp = props => {
  const { id, cx, cy, r, gradientTransform, gradientUnits } = props;
  return (
    <radialGradient id={id} cx={cx} cy={cy} r={r} gradientTransform={gradientTransform} gradientUnits={gradientUnits}>
      {props.children}
    </radialGradient>
  );
};

export const StopComp = props => {
  const { offset, stopColor } = props;
  return <stop offset={offset} stopColor={stopColor} />;
};

export const CirlceComp = props => {
  const { cx, cy, r, fill, stroke, strokeWidth, strokeOpacity } = props;
  return (
    <circle cx={cx} cy={cy} r={r} stroke={stroke} strokeOpacity={strokeOpacity} strokeWidth={strokeWidth} fill={fill} />
  );
};

export const TextComp = props => {
  const { fontFamily, fontSize, fontWeight, transform } = props;
  return (
    <text fontFamily={fontFamily} fontWeight={fontWeight} fontSize={fontSize} transform={transform}>
      {props.children}
    </text>
  );
};
export const TextSComp = props => {
  const { x, y } = props;
  return (
    <tspan x={x} y={y}>
      {props.children}
    </tspan>
  );
};

export const PathComp = ({
  d,
  fill,
  fillRule,
  stroke,
  strokeOpacity,
  strokeWidth,
  strokeLinecap,
  strokeLinejoin,
  clipRule,
  mask,
  fillOpacity,
  strokeDasharray
}) => (
  <path
    d={d}
    clipRule={clipRule}
    stroke={stroke}
    fill={fill}
    fillRule={fillRule}
    strokeOpacity={strokeOpacity}
    strokeWidth={strokeWidth}
    strokeLinecap={strokeLinecap}
    strokeLinejoin={strokeLinejoin}
    mask={mask}
    fillOpacity={fillOpacity}
    strokeDasharray={strokeDasharray}
  />
);

export const LineComp = props => {
  const { x1, x2, y1, y2, stroke, strokeLinecap, strokeLinejoin } = props;
  return (
    <line
      x1={x1}
      y1={y1}
      x2={x2}
      y2={y2}
      stroke={stroke}
      strokeLinecap={strokeLinecap}
      strokeLinejoin={strokeLinejoin}
    />
  );
};

export const RectComp = props => {
  const { width, height, fill, rx, ry, transform, stroke, fillOpacity, mask, x, y } = props;
  return (
    <rect
      width={width}
      height={height}
      fill={fill}
      rx={rx}
      ry={ry}
      transform={transform}
      stroke={stroke}
      fillOpacity={fillOpacity}
      mask={mask}
      x={x}
      y={y}
    />
  );
};
export const ClipPathComp = props => {
  const { id } = props;

  return <clipPath id={id}>{props.children}</clipPath>;
};

export const GComp = props => {
  const { fill, fillRule, clipPath, opacity, mask } = props;
  return (
    <g fill={fill} fillRule={fillRule} clipPath={clipPath} opacity={opacity} mask={mask}>
      {props.children}
    </g>
  );
};

export const SVGComp = props => {
  const { width, height, viewBox, deg = '0', style, xmlns } = props;
  return (
    <View style={[style, { transform: [{ rotate: `${deg}deg` }] }]}>
      <svg width={width} height={height} viewBox={viewBox} fill='none' xmlns={xmlns}>
        {props.children}
      </svg>
    </View>
  );
};

export const SVGPureComp = props => {
  const { width, height } = props;
  return (
    <svg width={width} height={height}>
      {props.children}
    </svg>
  );
};

export const MaskComp = props => {
  const { id, x, y, width, height, fill, style, maskUnits } = props;
  return (
    <mask id={id} x={x} y={y} width={width} height={height} fill={fill} style={style} maskUnits={maskUnits}>
      {props.children}
    </mask>
  );
};

export const PatternComp = props => <pattern {...props}>{props.children}</pattern>;
